import React, { createContext, useContext, ReactNode } from 'react';

export interface AppContextValue {
    basicData: any;
    municipalityData: any;
}

const AppContext = createContext<AppContextValue | undefined>(undefined);

export const useAppContext = (): AppContextValue => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within a AppContextProvider');
    }
    return context;
};

interface AppContextProviderProps extends AppContextValue {
    children: ReactNode;
}

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children, ...values }) => {
    return <AppContext.Provider value={values}>{children}</AppContext.Provider>;
};

export default AppContext;
